<template>
  <div>
    <b-card title="Merchant Report">
      <b-row class="mb-1" v-if="dataFiltered">
        <!-- search input -->

        <b-col>
          <b-form-group class="d-flex">
            <!-- search input -->
            <div>
              <b-form-input
                v-model="searchTerm"
                type="search"
                placeholder="search"
              />
            </div>
          </b-form-group>
        </b-col>

        <b-col class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row>

      <div>
        <!-- table -->
        <vue-good-table
          :columns="columns"
          :rows="reconciliations"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['5', '10', '15', '30', '50']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

        <!-- loadings -->
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    return {
      isLoading: false,
      dataFiltered: false,
      rows: [],
      pageLength: 5,
      dir: false,
      searchTerm: "",
      columns: [
        {
          label: "PNR",
          field: "pnr",
        },
        {
          label: "FlyGate OrderId",
          field: "flyGateOrderId",
        },

        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Vendor TxnRefNumber",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Paid Payment Option Name",
          field: "paidFop",
        },
        {
          label: "Paid Date",
          field: "paidDateTime",
        },
        {
          label: "Count",
          field: "responsesCount",
        },
        {
          label: "From Date",
          field: "fromDate",
        },
        {
          label: "To Date",
          field: "toDate",
        },
        {
          label: "Merchant Response Code",
          field: "responseCode",
        },

        {
          label: "Description",
          field: "description",
        },
      ],
      reconciliations: [],
      sheets: [{ name: "Detail Transactions", data: [] }],
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchMerchantReportDetail();
  },
  beforeCreate() {
    this.$http.get("/account-setting/data").then((res) => {
      this.options = res.data;
    });
  },
  methods: {
    fetchMerchantReportDetail() {
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Report-MerchantResponseGroup"
      );
      const url = `/Order/api/V1.0/Report/MerchantResponseGroupDetail?transactionStartDate=${this.$route.params.fromDate}&transactionEndDate=${this.$route.params.toDate}&merchantIds=${this.$route.params.merchantIds}&responseCode=${this.$route.params.responseCode}`;
      // Api call
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];

          this.dataFiltered = true;
          this.reconciliations = res.merchantResponseGroupingResponse;
          console.log(res.merchantResponseGroupingResponse);
          res.merchantResponseGroupingResponse.map((m) => {
            this.sheets[0].data.push({
              PNR: m.pnr,
              "Order Id": m.flyGateOrderId,
              amount: m.amount,
              "Vendor TxnRefNumber": m.vendorTxnRefNumber,
              "Paid Payment Option Name": m.paidFop,
              "Paid Date": m.paidDateTime,
              Count: m.responsesCount,
              "From Date": m.fromDate,
              "To Data": m.toDate,
              "Merchant Response Code": m.responseCode,
              Description: m.description,
            });
          });
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
          this.reconciliations = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
      this.merchantIds = "";
      this.trxnEndDate = "";
      this.trxnStartDate = "";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
